import React from 'react';
import { Link } from 'react-router-dom';

import './Style/Subjects.css';
import subjects from './Subjects';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';


function SubjectPage(props) {

  return (
    <div className="subject-page">

      <TopNavbar name={props.name} />
      <TopHeader name={props.name} />



      <div className="subject-categories">
        {subjects.map((subject) => (
          <Link
            to={`/${props.link}/${subject.name.toLowerCase().replace(' ', '-')}`}
            key={subject.id}
            className="subject-card"
            style={{ borderLeft: `5px solid ${subject.color}` }}
          >


            <div className="subject-card-row">
              <div className="subject-card-icon">
                <span style={{ fontSize: '50px', lineHeight: 1 }}>
                  {subject.icon}
                </span>
              </div>
              <h3>{subject.name} →</h3>
            </div>

          </Link>
        ))}
      </div>
    </div>


  );
}

export default SubjectPage;